module.exports = __webpack_public_path__ + "img/16.c23ac862.png";